import Typography from "@mui/material/Typography";
import { useHistory } from "react-router-dom";
import { Divider, Fade } from "@mui/material";

import { useAuth, useUnits } from "../../contexts";
import { formatCash } from "../../utils";
import { PageHeader } from "../../components";
import * as s from "./styles";

const MyProfile = () => {
  const history = useHistory();
  const { client } = useAuth();
  const { units } = useUnits();

  const clientUnit = units.find((u) => u.unitId === client.unitId);
  return (
    <Fade in timeout={1000}>
      <s.PageContainer>
        <PageHeader
          label={"Meu perfil"}
          handleBackPress={() => history.goBack()}
        />
        <s.PageContent>
          <Typography variant="caption" color="gray">
            Nome
          </Typography>
          <Typography>{client.name}</Typography>
          <Divider sx={{ mt: 1.5, mb: 1.5 }} />
          <Typography variant="caption" color="gray">
            CPF
          </Typography>
          <Typography>{client.cpf}</Typography>
          <Divider sx={{ mt: 1.5, mb: 1.5 }} />
          <Typography variant="caption" color="gray">
            Telefone
          </Typography>
          <Typography>{client.phone}</Typography>
          <Divider sx={{ mt: 1.5, mb: 1.5 }} />
          <Typography variant="caption" color="gray">
            Plano
          </Typography>
          <Typography>
            {client.plan} • Nível {client.level}
          </Typography>
          <Divider sx={{ mt: 1.5, mb: 1.5 }} />
          <Typography variant="caption" color="gray">
            Valor do plano
          </Typography>
          <Typography>{formatCash(client.planValue)}</Typography>
          <Divider sx={{ mt: 1.5, mb: 1.5 }} />
          <Typography variant="caption" color="gray">
            Vencimento do plano
          </Typography>
          <Typography>
            {new Date(client.dueDate).toLocaleDateString()}
          </Typography>
          <Divider sx={{ mt: 1.5, mb: 1.5 }} />
          <Typography variant="caption" color="gray">
            Unidade
          </Typography>
          <Typography>{clientUnit?.name}</Typography>
          <Divider sx={{ mt: 1.5, mb: 1.5 }} />
          <Typography variant="caption" color="gray">
            Data de cadastro
          </Typography>
          <Typography>
            {new Date(client.createdAt).toLocaleDateString()}
          </Typography>
          <Divider sx={{ mt: 1.5, mb: 1.5 }} />
        </s.PageContent>
      </s.PageContainer>
    </Fade>
  );
};

export default MyProfile;
